var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconM3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124 70",
    enableBackground: "new 0 0 124 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.4,42.6h3.2c0.9,0,1.6,0.2,2.1,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.8-0.3,1.5-0.8,1.9c-0.5,0.4-1.2,0.7-2.1,0.7h-2V51 h-1.2V42.6z M49.5,46.7c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.5-0.6,0.5-1.2c0-0.6-0.2-1-0.5-1.2c-0.3-0.2-0.8-0.4-1.3-0.4h-1.9v3.1 H49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8,50.5c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2V51h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8s-0.8,0.2-1.2,0.2C54.7,51.1,54.1,50.9,53.8,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,50.9c-0.4-0.2-0.7-0.4-1-0.8V51h-1.2v-8.9h1.2V46c0.3-0.3,0.6-0.5,1-0.7c0.4-0.2,0.9-0.2,1.3-0.2 c0.6,0,1.1,0.1,1.6,0.4c0.5,0.3,0.8,0.6,1.1,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.1-0.4,1.6c-0.3,0.5-0.6,0.8-1.1,1.1 c-0.5,0.3-1,0.4-1.6,0.4C63.5,51.1,63,51.1,62.6,50.9z M64.8,49.9c0.3-0.2,0.6-0.4,0.7-0.7c0.2-0.3,0.3-0.7,0.3-1.1 c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.4-0.6-0.7-0.7c-0.3-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.9,0.1-1.3,0.4c-0.4,0.3-0.6,0.6-0.8,1.1v1.3 c0.2,0.4,0.4,0.8,0.8,1s0.8,0.4,1.3,0.4C64.1,50.2,64.5,50.1,64.8,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,42.1h1.2V51h-1.2V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,43.9c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C71.6,44.1,71.5,44,71.3,43.9z M71.2,45.2h1.2V51h-1.2V45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,50.8c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C76.5,51.1,75.9,51,75.4,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,57h1.2v7.4h4.2v1h-5.5V57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2,58.3C48.1,58.1,48,58,48,57.8c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C48.5,58.5,48.4,58.4,48.2,58.3z M48.1,59.6h1.2v5.8 h-1.2V59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,65c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6s-0.8,0.2-1.2,0.2 C52.4,65.5,51.8,65.4,51.4,65z M54.4,64.4c0.3-0.2,0.5-0.4,0.7-0.6V63c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C53.8,64.6,54.1,64.5,54.4,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,65.3c-0.4-0.2-0.7-0.4-1-0.8v0.8h-1.2v-8.9h1.2v3.9c0.3-0.3,0.6-0.5,1-0.7c0.4-0.2,0.9-0.2,1.3-0.2 c0.6,0,1.1,0.1,1.6,0.4c0.5,0.3,0.8,0.6,1.1,1.1s0.4,1,0.4,1.6c0,0.6-0.1,1.1-0.4,1.6c-0.3,0.5-0.6,0.8-1.1,1.1s-1,0.4-1.6,0.4 C60.9,65.5,60.5,65.5,60.1,65.3z M62.2,64.3c0.3-0.2,0.6-0.4,0.7-0.7c0.2-0.3,0.3-0.7,0.3-1.1s-0.1-0.8-0.3-1.1 c-0.2-0.3-0.4-0.6-0.7-0.7c-0.3-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.9,0.1-1.3,0.4s-0.6,0.6-0.8,1.1v1.3c0.2,0.4,0.4,0.8,0.8,1.1 s0.8,0.4,1.3,0.4C61.5,64.6,61.9,64.5,62.2,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,58.3c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C66.3,58.5,66.1,58.4,66,58.3z M65.9,59.6h1.2v5.8h-1.2 V59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,56.5H70v8.9h-1.2V56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,58.3c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C72.1,58.5,71.9,58.4,71.8,58.3z M71.6,59.6h1.2v5.8 h-1.2V59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,65c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 s0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C76.2,65.5,75.7,65.4,75.4,65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,67.6v-0.9c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.4,0.4-0.7l0.3-0.7l-2.5-5.6h1.2l1.9,4.4 l1.8-4.4h1.2L81.9,66c-0.2,0.6-0.5,1-0.9,1.3c-0.3,0.3-0.8,0.4-1.3,0.4C79.3,67.7,79,67.7,78.7,67.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.5,28 c-2.4-0.3-4.8-2-5.8-2.9c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.3,2.7-5.7,3.1c-0.4,0.1-0.7,0.4-0.6,0.8c0.4,7.4,5.4,10.6,6.8,11.3 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.2-4.1,6.3-11.6C81.2,28.3,80.9,28,80.5,28z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 71.8,32.8 74,34.9 77.7,30.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "65,35.9 64.8,26.4 58.8,26.5 58.9,35.5 52.9,35.6  52.7,23.9 61.6,18 70.7,23.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "74.2,21.3 61.9,13.9 49.8,21.7  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M55.4,16.9 c0,0-2.1-3.3-5.7-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M54,16.9 c0,0-2.3,1.4-5.4-0.6c-3.2-2.1-3.8-1.7-3.8-1.7s1.7-2.9,5.6-2.8c3.9,0.1,4.5,2.8,4.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M55.2,10.8 c0,0,1.2,2.1,1.2,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M52.4,10.9 c0,0-1.4-2-1.2-3.9c0,0,3.1-0.5,5.5,1.6c2.4,2,1.4,5.4,1.4,5.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.5-30.9h1.2l3.3,8.4h-1.2l-0.8-2.1h-3.7l-0.8,2.1h-1.3L356.5-30.9z M358.5-25.6l-1.5-3.9l-1.5,3.9H358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3-31.4h1.2v8.9h-1.2V-31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1-31.4h1.2v8.9h-1.2V-31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.3-30.9h3.4c0.9,0,1.6,0.2,2.1,0.6c0.5,0.4,0.7,1.1,0.7,1.9c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.4-0.8,0.7-1.4,0.9l1.8,3.4 h-1.3l-1.8-3.3h-1.8v3.3h-1.2V-30.9z M375.4-26.9c0.5,0,1-0.1,1.3-0.4c0.3-0.3,0.5-0.6,0.5-1.1c0-0.5-0.2-0.9-0.5-1.2 c-0.3-0.2-0.7-0.3-1.3-0.3h-1.9v3H375.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380-29.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C380.3-29.4,380.1-29.5,380-29.6z M379.8-28.3h1.2v5.8h-1.2 V-28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6-22.5c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C384.5-22.3,384.1-22.4,383.6-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6-31.4h1.2v8.9h-1.2V-31.4z M389.8-25.4l2.7-2.8h1.5l-2.7,2.8l2.9,2.9h-1.5L389.8-25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9-30.9h1.2v8.4h-1.2V-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.7-28.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 h-1.2v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V-28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7-22.5c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C411.6-22.3,411.2-22.4,410.7-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3-23c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2v5.8h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8s-0.8,0.2-1.2,0.2C417.3-22.3,416.7-22.6,416.3-23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423-28.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H423V-28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.6-22.9c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6c-0.3,0.1-0.8,0.2-1.2,0.2 C428.6-22.3,428-22.5,427.6-22.9z M430.6-23.5c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C429.9-23.3,430.3-23.3,430.6-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434-28.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7h-1.2 v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9H434V-28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.6-22.7c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C443.6-22.3,443.1-22.5,442.6-22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5-23.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C449.9-22.3,449.1-22.6,448.5-23.1z M452.6-25.8 c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.9-27.3H459v-0.9h0.9v-1.1c0-0.7,0.2-1.2,0.6-1.5c0.4-0.3,0.9-0.5,1.5-0.5c0.3,0,0.6,0,0.9,0.1v1 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v1.1h1.4v0.9h-1.4v4.8h-1.2V-27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7-22.7c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C465.7-22.3,465.2-22.5,464.7-22.7z M467.9-23.9c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S467.5-23.5,467.9-23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471-28.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H471V-28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2-8.1c-0.5-0.1-0.8-0.2-1.1-0.3v-1.1c0.8,0.4,1.6,0.5,2.5,0.5c1.2,0,1.9-0.4,1.9-1.3c0-0.3-0.1-0.5-0.2-0.7 c-0.1-0.2-0.3-0.3-0.6-0.5s-0.7-0.3-1.2-0.5c-0.8-0.3-1.4-0.7-1.7-1.1s-0.5-0.9-0.5-1.5c0-0.4,0.1-0.8,0.4-1.2s0.6-0.6,1-0.8 c0.4-0.2,0.9-0.3,1.5-0.3c0.5,0,0.9,0,1.2,0.1c0.4,0.1,0.7,0.2,1.1,0.3v1.1c-0.7-0.3-1.4-0.5-2.1-0.5c-0.6,0-1,0.1-1.3,0.3 s-0.5,0.5-0.5,0.9c0,0.3,0.1,0.5,0.2,0.7s0.3,0.3,0.6,0.5c0.3,0.1,0.6,0.3,1.2,0.5c0.6,0.2,1,0.5,1.3,0.7s0.6,0.5,0.8,0.8 s0.3,0.7,0.3,1.1c0,0.7-0.3,1.3-0.8,1.7c-0.5,0.4-1.3,0.6-2.3,0.6C392.2-7.9,391.7-8,391.2-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5-8.4c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 s0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C398.3-7.9,397.8-8.1,397.5-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4-8.3c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.2-1.1,0.4-1.7,0.4C403.5-7.9,402.9-8.1,402.4-8.3z M405.6-9.5c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5s-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S405.2-9.1,405.6-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.9-8.3c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6s0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C410.9-7.9,410.4-8.1,409.9-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.1-17h1.2v8.9h-1.2V-17z M416.3-11l2.7-2.8h1.5l-2.7,2.8l2.9,2.9h-1.5L416.3-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7-8.3c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C428.7-7.9,428.2-8.1,427.7-8.3z M430.9-9.5c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5s0.9,0.6,1.5,0.6 S430.5-9.1,430.9-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434-13.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H434V-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.4,5.9c-0.7-0.4-1.2-0.9-1.6-1.5s-0.6-1.4-0.6-2.3s0.2-1.6,0.6-2.3c0.4-0.7,0.9-1.2,1.6-1.5c0.7-0.4,1.4-0.5,2.3-0.5 c1.2,0,2.1,0.3,2.9,0.9v1.2c-0.7-0.6-1.6-0.9-2.8-0.9c-0.6,0-1.2,0.1-1.7,0.4c-0.5,0.3-0.9,0.6-1.2,1.1c-0.3,0.5-0.4,1.1-0.4,1.7 s0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.1c0.5,0.3,1.1,0.4,1.7,0.4c0.6,0,1.1-0.1,1.6-0.2c0.5-0.2,0.9-0.4,1.3-0.8v1.2 c-0.7,0.6-1.7,0.9-3,0.9C380.9,6.5,380.1,6.3,379.4,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.1,6.1c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C388.1,6.5,387.6,6.3,387.1,6.1z M390.3,4.9c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S389.9,5.3,390.3,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4,0.5h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 h-1.2V2.7c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,6.3c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C402.3,6.5,401.9,6.4,401.4,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.1,6c-0.3-0.3-0.5-0.8-0.5-1.4V1.5h-0.9V0.5h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C407.9,6.5,407.5,6.3,407.1,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8,0.5h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,5.8c-0.4-0.4-0.6-1-0.6-1.7V0.5h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1V0.5h1.2v5.8H420V5.5 c-0.3,0.3-0.6,0.6-1,0.8s-0.8,0.2-1.2,0.2C417,6.5,416.4,6.2,416,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,6.1c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1s1.1-0.4,1.7-0.4 c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.7,0.2,1.2,0.6,1.6 c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1C425.1,6.5,424.5,6.3,424,6.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,6c-0.3-0.3-0.5-0.8-0.5-1.4V1.5h-0.9V0.5h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C430.9,6.5,430.4,6.3,430.1,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434-0.8c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5S435.1-1,435-0.8c-0.1,0.1-0.3,0.2-0.5,0.2C434.3-0.6,434.1-0.7,434-0.8z M433.8,0.5h1.2v5.8h-1.2V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.1,6.1c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C439.1,6.5,438.6,6.3,438.1,6.1z M441.3,4.9c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S440.9,5.3,441.3,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.4,0.5h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 h-1.2V2.7c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V0.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 394.5,-52.7 394.5,-62.3 413.2,-69.8 432.8,-62.3 432.8,-39.2 398.4,-39.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 385.7,-62 413.7,-73.5 440.7,-62  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.6,
    y: -60.2,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 25.6,
    height: 21
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 400.6,
    y1: -51,
    x2: 426.2,
    y2: -51
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 405,
    y1: -57.3,
    x2: 421.4,
    y2: -57.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 405,
    y1: -54.5,
    x2: 421.4,
    y2: -54.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.8,
    y: -44.1,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.6,
    y: -44.1,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: -48.9,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 7,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M397.5-48.8 c-2.5-0.3-5-2.2-6-3.1c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.4,2.8-6,3.1c-0.4,0-0.7,0.4-0.7,0.8c0.3,7.7,5.4,11,6.8,11.8 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.5-4.2,6.8-11.8C398.2-48.4,397.9-48.7,397.5-48.8z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 388.2,
    y1: -44.1,
    x2: 393.9,
    y2: -44.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 391,
    y1: -46.9,
    x2: 391,
    y2: -41.2
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.1,55.3h5.5v1h-4.3V59h3.2v1h-3.2v3.7h-1.2V55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,56.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C253.8,56.8,253.6,56.7,253.5,56.6z M253.4,57.9h1.2v5.8h-1.2V57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,57.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,63.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C262.8,63.8,262,63.6,261.4,63.1z M265.6,60.4 c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,69.7h1.2v8.4H230V69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8,72.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,78.1c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.5c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2s-1,0.4-1.8,0.4C241.7,78.2,241.3,78.2,240.8,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,77.6c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2v5.8h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.2-1.2,0.2C247.3,78.2,246.8,78,246.4,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,72.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H253V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,77.7c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6s-0.8,0.2-1.2,0.2 C258.6,78.2,258.1,78.1,257.7,77.7z M260.7,77.1c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C260,77.3,260.4,77.2,260.7,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,72.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8v3.9h-1.2V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6,77.9c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6s0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C273.7,78.2,273.1,78.1,272.6,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5,77.5c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.8,0.6,1,1 c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.2,1-0.3v1 c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C280,78.2,279.1,78,278.5,77.5z M282.7,74.8c0-0.5-0.2-1-0.5-1.3 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H282.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M277.3,37.4 c-2.5-0.3-5-2.2-6-3.1c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.4,2.8-6,3.1c-0.4,0-0.7,0.4-0.7,0.8c0.3,7.7,5.4,11,6.8,11.8 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.5-4.2,6.8-11.8C278,37.8,277.7,37.4,277.3,37.4z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 267.9,
    y1: 42.1,
    x2: 273.7,
    y2: 42.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 270.8,
    y1: 39.2,
    x2: 270.8,
    y2: 45
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M263.8,48.3c-1.8,1.3-4.3,2.2-8.1,2.7c4-2.1,7.6-5.2,6.7-9.7c-0.4,0.4-1.5,1.5-2.6,2c0.6-2.9-1.1-6-3.9-7.6 c1.6,2.1,1,5.3-1.4,6.8c-2.2-0.5-4.2-1.8-5.2-3.5c-0.7,1.9-1.2,4.3-0.4,6.2c0.8,2.1,1.6,3.2,4.4,5.8c-4-1.3-7.1-4.2-8.2-7.7 c-1.1-3.6-0.1-7.6,2.6-10.4c0.9,1.7,2.7,3.1,4.8,3.6c-2.8-3-3.8-7.1-2.8-10.9c1.1-3.7,4.2-7,8.3-8.7c-2.7,2.7-3.2,6.9-1.2,10 c1.9,3,5.9,5,7.4,8.2c0.2-0.8,0.4-1.6,0.6-2.4c0-0.1,0.1-0.2,0.1-0.3c0.6,0.5,1.2,1.2,1.6,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M256.6,44.3c-0.1-0.1-0.2-0.3-0.2-0.4c-0.5,1.1-0.9,0.9-1.4,1.5c-0.3,0.3-0.4,0.7-0.4,1c0,0-0.1-0.6-0.8-0.8 c-0.5-0.2-1.1-0.3-1.3-0.7c-0.5,1.9,1.2,3.1,1.9,4.1c0.2-0.2,0.5-0.2,0.7-0.4c0.8-0.4,1.3-0.6,1.9-1.1c0.6-0.5,1.1-1.3,1.3-2 c-0.4,0.3-1,0.5-1.6,0.5C257.2,45.4,256.9,44.8,256.6,44.3z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.4,55.3h1.2l3,6.5l3-6.5h1.2v8.4h-1.2v-6l-2.7,6h-0.6l-2.7-6v6h-1.2V55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,63.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C409.8,63.8,409.2,63.7,408.7,63.5z M411.9,62.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S411.5,62.7,411.9,62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.7,63.3c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 s0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C416.5,63.8,416,63.7,415.7,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.6,63.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.2-1.1,0.4-1.7,0.4C421.7,63.8,421.1,63.7,420.6,63.5z M423.8,62.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5s-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S423.4,62.7,423.8,62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.9,57.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,69.7h1.2v8.4H387V69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,72.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.8,78.1c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.5c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2s-1,0.4-1.8,0.4C398.7,78.2,398.3,78.2,397.8,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,77.6c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2v5.8h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.2-1.2,0.2C404.3,78.2,403.8,78,403.4,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,72.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H410V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.7,77.7c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6s-0.8,0.2-1.2,0.2 C415.6,78.2,415.1,78.1,414.7,77.7z M417.7,77.1c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C417,77.3,417.4,77.2,417.7,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.1,72.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8v3.9h-1.2V72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.6,77.9c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6s0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C430.7,78.2,430.1,78.1,429.6,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.5,77.5c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.8,0.6,1,1 c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.2,1-0.3v1 c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C437,78.2,436.1,78,435.5,77.5z M439.7,74.8c0-0.5-0.2-1-0.5-1.3 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H439.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M425.6,46.6H399 v-3.1c0-2.7,2.2-4.8,4.8-4.8h16.9c2.7,0,4.8,2.2,4.8,4.8V46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M406,46.6v1.8 c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M424.2,46.6v1.8 c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M403.1,44.5h-2.3 c-0.4,0-0.8-0.3-0.8-0.8v-0.4c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v0.4C403.8,44.2,403.5,44.5,403.1,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M423.8,44.5h-2.3 c-0.4,0-0.8-0.3-0.8-0.8v-0.4c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v0.4C424.6,44.2,424.3,44.5,423.8,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M414.3,43.6h-4 c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h4c0.6,0,1.1,0.5,1.1,1.1l0,0C415.4,43.1,414.9,43.6,414.3,43.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M430.2,19.4 c-2.1-0.3-4.2-1.8-5-2.6c-0.2-0.2-0.6-0.2-0.8,0c-0.9,0.7-2.9,2.3-5,2.6c-0.3,0-0.6,0.3-0.6,0.7c0.3,6.4,4.5,9.3,5.7,9.9 c0.2,0.1,0.4,0.1,0.6,0c1.2-0.7,5.4-3.5,5.7-9.9C430.8,19.7,430.5,19.4,430.2,19.4z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 422.4,
    y1: 23.4,
    x2: 427.2,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 424.8,
    y1: 21,
    x2: 424.8,
    y2: 25.8
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 422.7,
    y1: 34.5,
    x2: 422.7,
    y2: 38.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M401.9,38.7v-7 c0-3.3,3.1-5.9,6.9-5.9h7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M404,38.7v-5.6 c0-2.6,2.5-4.8,5.5-4.8h5.6c3,0,5.5,2.2,5.5,4.8v5.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M398.9,39.1 L398.9,39.1c-0.6,0-1-0.5-1-1V36c0-0.6,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1v2.1C400,38.7,399.5,39.1,398.9,39.1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 400,
    y1: 37.1,
    x2: 401.9,
    y2: 37.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M426.1,39.1 L426.1,39.1c0.6,0,1-0.5,1-1V36c0-0.6-0.5-1-1-1l0,0c-0.6,0-1,0.5-1,1v2.1C425.1,38.7,425.6,39.1,426.1,39.1z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 425.1,
    y1: 37.1,
    x2: 423.2,
    y2: 37.1
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 407.4,
    y1: 37.3,
    x2: 414.7,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 416.8,
    y1: 32.9,
    x2: 414,
    y2: 35.9
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.6,141.3h3.2c0.9,0,1.6,0.2,2.1,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.8-0.3,1.5-0.8,1.9c-0.5,0.4-1.2,0.7-2.1,0.7h-2v3.2 h-1.2V141.3z M211.7,145.4c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.5-0.6,0.5-1.2c0-0.6-0.2-1-0.5-1.2c-0.3-0.2-0.8-0.4-1.3-0.4h-1.9v3.1 H211.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5,149.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C217.5,149.8,217,149.7,216.5,149.5z M219.7,148.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S219.3,148.7,219.7,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,140.8h1.2v8.9h-1.2V140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,142.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C226.1,142.8,225.9,142.7,225.8,142.6z M225.7,143.9h1.2v5.8h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,149.3c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C230.2,149.8,229.8,149.7,229.4,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,142.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C233.6,142.8,233.4,142.7,233.3,142.6z M233.2,143.9h1.2v5.8 h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4,149.5c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C238.5,149.8,237.9,149.7,237.4,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,149.3c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5V146 c0-0.5-0.1-0.8-0.4-1s-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1V149c-0.2,0.3-0.5,0.5-0.9,0.6c-0.3,0.1-0.8,0.2-1.2,0.2 C243.9,149.8,243.4,149.7,242.9,149.3z M246,148.7c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C245.3,148.9,245.7,148.8,246,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,140.8h1.2v8.9h-1.2V140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,141.3h1.3l2.6,6.7l2.6-6.7h1.3l-3.3,8.4h-1.2L256.4,141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,142.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C265.3,142.8,265.1,142.7,265,142.6z M264.9,143.9h1.2v5.8 h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,149.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C270.2,149.8,269.6,149.7,269.1,149.5z M272.3,148.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S271.9,148.7,272.3,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,140.8h1.2v8.9h-1.2V140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,149.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C280.3,149.8,279.5,149.6,278.9,149.1z M283,146.4 c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5,143.9h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 H290v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,149.5c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C295.1,149.8,294.5,149.7,294,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,149.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C301.3,149.8,300.5,149.6,299.9,149.1z M304.1,146.4 c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,155.7h1.2v8.4H230V155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8,158.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,164.1c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.5c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2s-1,0.4-1.8,0.4C241.7,164.2,241.3,164.2,240.8,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,163.6c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2v5.8h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.2-1.2,0.2C247.3,164.2,246.8,164,246.4,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,158.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H253V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,163.7c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6s-0.8,0.2-1.2,0.2 C258.6,164.2,258.1,164.1,257.7,163.7z M260.7,163.1c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5 c-0.5,0-0.8,0.1-1,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C260,163.3,260.4,163.2,260.7,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,158.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8v3.9h-1.2V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6,163.9c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6s0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C273.7,164.2,273.1,164.1,272.6,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5,163.5c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C280,164.2,279.1,164,278.5,163.5z M282.7,160.8 c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H282.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M260.7,115.2 l0,0.5c-0.1,0.9-0.4,1.8-0.9,2.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M259.1,111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M259.6,108.3 l2.9-2.9c0.6-0.6,1.6-0.6,2.2,0l0,0c0.6,0.6,0.6,1.6,0,2.2l-2.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M262.5,109.9 l2.8-2.8c0.6-0.6,1.6-0.6,2.2,0l0,0c0.6,0.6,0.6,1.6,0,2.2l-4.7,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M263.6,115.5 L263.6,115.5c-0.6-0.6-0.6-1.6,0-2.2l3.3-3.3c0.6-0.6,1.6-0.6,2.2,0l0,0c0.6,0.6,0.6,1.6,0,2.2l-3.3,3.3 C265.3,116.1,264.3,116.1,263.6,115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M265.3,118.2 L265.3,118.2c-0.6-0.6-0.6-1.6,0-2.2l3.5-3.5c0.6-0.6,1.6-0.6,2.2,0h0c0.6,0.6,0.6,1.6,0,2.2l-3.5,3.5 C267,118.9,266,118.9,265.3,118.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M255.3,110.7 c0-1.3,1.1-2.4,2.4-2.4l2.3-0.1c1.3,0,2.4,1.1,2.4,2.4v4.5l-1.1,0c-1.2,0-2.2-1-2.2-2.2v-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M257,125.1 l3.4-3.4l0,0c1.3,0.6,2.9,0.3,3.9-0.7l2.1-2.1"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M260.7,102.1 c3.3,1,4.9,0.3,6.7-2.8c1.8,3,3.4,3.7,6.7,2.8c-1,3.3-0.3,4.9,2.8,6.7c-3,1.8-3.7,3.4-2.8,6.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M256.2,113.2 c-3-0.4-6-2.7-7.2-3.7c-0.3-0.3-0.9-0.3-1.2,0c-1.2,1.1-4.2,3.3-7.2,3.7c-0.5,0.1-0.8,0.5-0.8,1c0.4,9.3,6.5,13.3,8.2,14.3 c0.3,0.2,0.6,0.2,0.9,0c1.7-1,7.8-5,8.2-14.3C257.1,113.7,256.7,113.3,256.2,113.2z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 245,
    y1: 118.9,
    x2: 251.9,
    y2: 118.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 248.4,
    y1: 115.5,
    x2: 248.4,
    y2: 122.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 262.4,
    y1: 123.9,
    x2: 273.5,
    y2: 123.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 268,
    y1: 123.9,
    x2: 268,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 264.4,
    y1: 135.7,
    x2: 271.6,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M273.5,130.7 L273.5,130.7c-1.1,0-2.1-0.6-2.6-1.6l-0.5-1h6.2l-0.5,1C275.6,130,274.6,130.7,273.5,130.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 271.3,127.7 273.5,123.9 275.7,127.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M262.4,130.7 L262.4,130.7c-1.1,0-2.1-0.6-2.6-1.6l-0.5-1h6.2l-0.5,1C264.6,130,263.5,130.7,262.4,130.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 260.2,127.7 262.4,123.9 264.6,127.7  "
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.6,141.3h5.5v1h-4.3v2.7h3.2v1h-3.2v2.7h4.3v1h-5.5V141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,143.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,149.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 s0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.2,1-0.3v1 c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C380.9,149.8,380.1,149.6,379.5,149.1z M383.6,146.4c0-0.5-0.2-1-0.5-1.3 c-0.3-0.3-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,149.5c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C388.5,149.8,387.9,149.7,387.4,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5,149.3c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 s0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C394.3,149.8,393.8,149.7,393.5,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,142.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C397.7,142.8,397.5,142.7,397.4,142.6z M397.2,143.9h1.2v5.8h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,149.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.2-1.1,0.4-1.7,0.4C402.5,149.8,402,149.7,401.5,149.5z M404.7,148.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5s-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S404.3,148.7,404.7,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.8,143.9h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 h-1.2v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,141.3h1.2l3.3,8.4h-1.2l-0.8-2.1h-3.7l-0.8,2.1h-1.3L422.5,141.3z M424.6,146.6l-1.5-3.9l-1.5,3.9H424.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,140.8h1.2v8.9h-1.2V140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.2,140.8h1.2v8.9h-1.2V140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4,141.3h3.4c0.9,0,1.6,0.2,2.1,0.6c0.5,0.4,0.7,1.1,0.7,1.9c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.4-0.8,0.7-1.4,0.9 l1.8,3.4h-1.3l-1.8-3.3h-1.8v3.3h-1.2V141.3z M441.5,145.3c0.5,0,1-0.1,1.3-0.4c0.3-0.3,0.5-0.6,0.5-1.1c0-0.5-0.2-0.9-0.5-1.2 c-0.3-0.2-0.7-0.3-1.3-0.3h-1.9v3H441.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,142.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C446.4,142.8,446.2,142.7,446,142.6z M445.9,143.9h1.2v5.8h-1.2V143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.7,149.7c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2s-1,0.4-1.8,0.4C450.6,149.8,450.1,149.8,449.7,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,140.8h1.2v8.9h-1.2V140.8z M455.9,146.8l2.7-2.8h1.5l-2.7,2.8l2.9,2.9h-1.5L455.9,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,155.7h1.2v8.4H387V155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,158.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.8,164.1c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.5c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2s-1,0.4-1.8,0.4C398.7,164.2,398.3,164.2,397.8,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,163.6c-0.4-0.4-0.6-1-0.6-1.7v-3.6h1.2v3.6c0,0.9,0.5,1.4,1.4,1.4c0.8,0,1.4-0.4,1.9-1.1v-3.9h1.2v5.8h-1.2v-0.8 c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.2-1.2,0.2C404.3,164.2,403.8,164,403.4,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,158.3h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6H410V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.7,163.7c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5v-0.3 c0-0.5-0.1-0.8-0.4-1c-0.3-0.2-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1v-0.6c-0.2,0.3-0.5,0.5-0.9,0.6s-0.8,0.2-1.2,0.2 C415.6,164.2,415.1,164.1,414.7,163.7z M417.7,163.1c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5 c-0.5,0-0.8,0.1-1,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C417,163.3,417.4,163.2,417.7,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.1,158.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8v3.9h-1.2V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.6,163.9c-0.5-0.2-0.9-0.6-1.2-1c-0.3-0.5-0.4-1-0.4-1.6s0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.2,1.1-0.4,1.7-0.4c0.9,0,1.6,0.2,2.1,0.5v1c-0.5-0.4-1.2-0.5-2-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.6 s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.5,1.6,0.5c0.8,0,1.5-0.2,2.1-0.6v1c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0.1-0.8,0.1-1.3,0.1 C430.7,164.2,430.1,164.1,429.6,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.5,163.5c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C437,164.2,436.1,164,435.5,163.5z M439.7,160.8 c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H439.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M408.1,114.7 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.9,5.5,11.3,6.9,12.1 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C408.8,115.1,408.5,114.7,408.1,114.7z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 398.6,
    y1: 119.5,
    x2: 404.4,
    y2: 119.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 401.5,
    y1: 116.6,
    x2: 401.5,
    y2: 122.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M429.6,100 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.9,5.5,11.3,6.9,12.1 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C430.3,100.4,430,100.1,429.6,100z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 420.2,105 422.5,107.2 426.6,103  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M431.6,121.7 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.9,5.5,11.3,6.9,12.1 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C432.3,122.1,432,121.7,431.6,121.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.7,130.5c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.7-0.2-1-0.3v-0.7c0.7,0.3,1.4,0.4,2.2,0.4v-2.7c0,0,0,0-0.1,0 c-0.7-0.3-1.3-0.5-1.6-0.9c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.6-1.2c0.4-0.3,0.9-0.5,1.5-0.6v-0.9h0.8v0.9 c0.6,0,1.2,0.1,1.7,0.3v0.7c-0.6-0.2-1.1-0.3-1.7-0.4v2.7c0.5,0.2,0.9,0.3,1.2,0.5c0.3,0.2,0.5,0.4,0.7,0.6 c0.2,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.5,1.2s-0.9,0.5-1.5,0.6v0.9h-0.8V130.5z M424.7,124c-0.4,0.1-0.7,0.2-1,0.4 c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.4,1,0.6V124z M426.6,128.7c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.5-0.3-0.9-0.5v2.4C426.2,129.7,426.6,129.3,426.6,128.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M405,110.3 c1.9-3.2,5.1-5.7,8.8-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M415.6,131.3 c-3.6-0.4-6.8-2.2-9.1-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M429.8,111.3 c0.9,1.8,1.4,3.9,1.4,6c0,1-0.1,2-0.3,2.9"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.9,227.3h3.2c0.9,0,1.6,0.2,2.1,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.8-0.3,1.5-0.8,1.9c-0.5,0.4-1.2,0.7-2.1,0.7h-2v3.2 h-1.2V227.3z M305,231.4c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.5-0.6,0.5-1.2c0-0.6-0.2-1-0.5-1.2c-0.3-0.2-0.8-0.4-1.3-0.4h-1.9v3.1 H305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,229.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,235.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C316.1,235.8,315.6,235.7,315.1,235.5z M318.3,234.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S317.9,234.7,318.3,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,230.8h-0.9v-0.9h0.9v-1.1c0-0.7,0.2-1.2,0.6-1.5c0.4-0.3,0.9-0.5,1.5-0.5c0.3,0,0.6,0,0.9,0.1v1 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v1.1h1.4v0.9h-1.4v4.8h-1.2V230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.9,235.1c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C327.3,235.8,326.5,235.6,325.9,235.1z M330,232.4 c0-0.5-0.2-1-0.5-1.3s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H330z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,235.7c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C334.2,235.8,333.8,235.8,333.4,235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,235.7c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C339.8,235.8,339.4,235.8,338.9,235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,228.6c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C344.5,228.8,344.3,228.7,344.1,228.6z M344,229.9h1.2v5.8H344V229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.3,235.5c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.2-1.1,0.4-1.7,0.4C349.3,235.8,348.8,235.7,348.3,235.5z M351.5,234.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5s-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S351.1,234.7,351.5,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,229.9h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7 h-1.2v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,235.3c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5V232 c0-0.5-0.1-0.8-0.4-1s-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6h-1.1V235c-0.2,0.3-0.5,0.5-0.9,0.6c-0.3,0.1-0.8,0.2-1.2,0.2 C363,235.8,362.4,235.7,362,235.3z M365,234.7c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C364.4,234.9,364.7,234.8,365,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4,226.8h1.2v8.9h-1.2V226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,241.7h1.2v8.4h-1.2V241.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,244.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6v3.7H319v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8v3.9h-1.2V244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,249.9c-0.5-0.3-0.8-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.6-0.8,1.1-1.1 c0.5-0.3,1-0.4,1.6-0.4c1,0,1.8,0.3,2.4,0.9v-3.9h1.2v8.9h-1.2v-0.8c-0.3,0.4-0.7,0.6-1,0.8s-0.8,0.2-1.3,0.2 C323.9,250.2,323.4,250.1,323,249.9z M326.1,248.9c0.4-0.3,0.6-0.6,0.8-1.1v-1.3c-0.1-0.4-0.4-0.8-0.8-1.1s-0.8-0.4-1.3-0.4 c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.7-0.3,1.1s0.1,0.8,0.3,1.1c0.2,0.3,0.4,0.6,0.7,0.7 c0.3,0.2,0.7,0.3,1.1,0.3C325.3,249.3,325.7,249.2,326.1,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.3,249.5c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C331.7,250.2,330.9,250,330.3,249.5z M334.5,246.8 c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,244.3h1.2v0.8c0.3-0.3,0.6-0.6,0.9-0.8c0.3-0.2,0.7-0.3,1.1-0.3c0.5,0,0.8,0.1,1.1,0.2c0.3,0.2,0.5,0.4,0.6,0.7 c0.3-0.3,0.6-0.5,0.9-0.7s0.7-0.2,1.1-0.2c0.7,0,1.2,0.2,1.5,0.5c0.3,0.4,0.5,0.9,0.5,1.6v3.8h-1.2v-3.7c0-0.5-0.1-0.8-0.3-1 c-0.2-0.2-0.5-0.3-0.9-0.3c-0.6,0-1.1,0.3-1.5,0.8c0,0.1,0,0.3,0,0.6v3.6h-1.2v-3.7c0-0.5-0.1-0.8-0.2-1 c-0.2-0.2-0.4-0.3-0.9-0.3c-0.6,0-1.2,0.3-1.6,1v3.9h-1.2V244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,243c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C347.8,243.2,347.7,243.1,347.5,243z M347.4,244.3h1.2 v5.8h-1.2V244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.2,249.7c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9h0.9v-1.7h1.2v1.7h1.4v0.9H352v3c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C352,250.2,351.5,250.1,351.2,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,252.3v-0.9c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.4,0.4-0.7l0.3-0.7l-2.5-5.6h1.2l1.9,4.4 l1.8-4.4h1.2l-2.6,6.4c-0.2,0.6-0.5,1-0.9,1.3c-0.3,0.3-0.8,0.4-1.3,0.4C355.1,252.4,354.8,252.4,354.5,252.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M328.6,208.5 l3.1-3.1c1.9-1.9,4.5-3,7.2-3h6.2c0.8,0,1.3,0.8,0.9,1.5l0,0c-0.8,1.5-2.4,2.4-4.1,2.4h-2.7v1.9h9.8l5.7-5.7 c1.1-1.1,3-0.8,3.7,0.6l0,0c0.4,0.9,0.3,1.9-0.4,2.6l-6.8,6.9c-1.5,1.6-3.7,2.4-5.9,2.4h-10.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 334.7,220.1 335.8,218.4 325.3,208.6 316.2,219  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 322.9,
    y1: 211.2,
    x2: 331.1,
    y2: 219.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M353.3,183.3 c-2.5-0.3-5-2.2-6-3.1c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.5,2.8-6,3.1c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.7,5.4,11.1,6.8,12 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.5-4.2,6.8-12C354,183.7,353.7,183.3,353.3,183.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.4,192c-0.4,0-0.8,0-1.2-0.1s-0.7-0.1-1-0.3v-0.7c0.7,0.3,1.4,0.4,2.2,0.4v-2.7c0,0,0,0-0.1,0 c-0.7-0.3-1.2-0.5-1.6-0.8c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.6-1.2c0.4-0.3,0.9-0.5,1.5-0.5V184h0.7v0.9 c0.6,0,1.2,0.1,1.7,0.3v0.7c-0.6-0.2-1.1-0.3-1.7-0.3v2.6c0.5,0.2,0.9,0.3,1.1,0.5c0.3,0.2,0.5,0.3,0.6,0.6 c0.2,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.5,0.6v0.9h-0.7V192z M346.4,185.6 c-0.4,0.1-0.7,0.2-0.9,0.3s-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.4,1,0.6V185.6z M348.4,190.1 c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-0.9-0.5v2.3C348,191.1,348.4,190.8,348.4,190.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 336.8,
    y1: 178,
    x2: 339,
    y2: 180.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 354.8,
    y1: 196,
    x2: 356.9,
    y2: 198.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 356.9,
    y1: 178,
    x2: 354.8,
    y2: 180.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 339,
    y1: 196,
    x2: 336.8,
    y2: 198.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 334.1,
    y1: 188,
    x2: 335.7,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 358.1,
    y1: 188,
    x2: 359.6,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 346.9,
    y1: 175.3,
    x2: 346.9,
    y2: 176.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 346.9,
    y1: 199.2,
    x2: 346.9,
    y2: 200.8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconM3);
export default __webpack_public_path__ + "static/media/icon-m-3.dd7838f86d8d38f13a47e8823e836df2.svg";
export { ForwardRef as ReactComponent };